import CreativeLibrary from '../pages/campaigns/creatives/creativeLibrary'
import AdLibrary from '../pages/campaigns/creatives/adLibrary'
import NewCreative from '../pages/campaigns/creatives/newCreative'
import EditCreative from '../pages/campaigns/creatives/editCreative'
import CloneCreative from '../pages/campaigns/creatives/cloneCreative'
import AddToCampaign from '../pages/campaigns/creatives/addToCampaign'

export const CampaignCreatives = [
    {
        path: ':id/creative-library',
        element: <CreativeLibrary />,
    },
    {
        path: ':id/ad-library',
        element: <AdLibrary />,
    },
    {
        path: ':id/new-creative',
        element: <NewCreative />,
    },
    {
        path: ':id/edit-creative/:creativeId',
        element: <EditCreative />,
    },
    {
        path: ':id/clone-creative/:creativeId',
        element: <CloneCreative />,
    },
    {
        path: ':id/creatives/add-to-campaign',
        element: <AddToCampaign />,
    },
]

export default CampaignCreatives
